import type { CSSProperties, ReactNode } from 'react'

export interface LegalDocProps {
  children: ReactNode
  effectiveDate: string
  footer?: ReactNode
  header?: ReactNode
  /** Short intro paragraph rendered under the title, optional. */
  intro?: ReactNode
  title: string
  version: string
}

const page: CSSProperties = {
  background: 'var(--bg)',
  color: 'var(--text)',
  minHeight: '100vh',
}

const article: CSSProperties = {
  lineHeight: 1.7,
  margin: '0 auto',
  maxWidth: 760,
  padding: '40px 20px 80px',
}

export function LegalDoc({
  children,
  effectiveDate,
  footer,
  header,
  intro,
  title,
  version,
}: LegalDocProps) {
  return (
    <div style={page}>
      <style>{`
        .tc-legal-doc h2 { font-family: 'Clash Display', sans-serif; font-size: 19px; font-weight: 700; margin: 30px 0 10px; color: var(--text); }
        .tc-legal-doc h3 { font-size: 15px; font-weight: 600; margin: 18px 0 6px; color: var(--text); }
        .tc-legal-doc p { margin: 0 0 14px; color: var(--text-dim); font-size: 14.5px; }
        .tc-legal-doc ul { margin: 0 0 14px; padding-left: 20px; color: var(--text-dim); font-size: 14.5px; }
        .tc-legal-doc li { margin: 0 0 6px; }
        .tc-legal-doc a { color: var(--lime); text-decoration: none; }
        .tc-legal-doc a:hover { text-decoration: underline; }
        .tc-legal-doc strong { color: var(--text); }
        .tc-legal-doc .legal-note { background: var(--bg2); border: 1px solid var(--lime-line); border-radius: 10px; padding: 14px 16px; margin: 0 0 18px; font-size: 13.5px; color: var(--muted); }
      `}</style>
      {header}
      <article className="tc-legal-doc" style={article}>
        <h1
          style={{
            color: 'var(--lime)',
            fontFamily: 'Clash Display, sans-serif',
            fontSize: 30,
            fontWeight: 700,
            margin: '0 0 6px',
          }}
        >
          {title}
        </h1>
        <p style={{ color: 'var(--muted)', fontSize: 13, margin: '0 0 28px' }}>
          Version {version} · Effective {effectiveDate}
        </p>
        {intro}
        {children}
      </article>
      {footer}
    </div>
  )
}
